<template>
  <button id="modalBtn" type="button" class="btn btn-primary d-none" data-toggle="modal"
          data-target="#exampleModalCenter">
    Launch demo modal
  </button>
  <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
       aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-primary font-weight-bold" id="exampleModalLongTitle">
            {{ t('changesWereMadeModal.header')}}
          </h5>
          <button type="button" class="close" @click="continueForm" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p> {{ t('changesWereMadeModal.navrat')}} <strong> {{ t('changesWereMadeModal.tlacitko')}}
            <span class="bg-primary text-white py-1 px-3"> {{ t('changesWereMadeModal.zpet')}}</span>
            {{ t('changesWereMadeModal.ve')}}</strong>  {{ t('changesWereMadeModal.pouziti')}}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn bg-muted font-weight-light mr-auto" data-dismiss="modal" @click="leaveForm">
            {{ t('changesWereMadeModal.odejitBtn')}}
          </button>
          <button type="button" class="btn btn-primary" data-dismiss="modal" @click="continueForm">
            {{ t('changesWereMadeModal.zustatBtn')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {store} from "../store";
import {useI18n} from "vue-i18n";
export default {
  setup(){
    const {t} = useI18n({useScope: 'global'})
    return {t}
  },
  mounted() {
    const form = document.getElementById('appJakeTrade')
    form.addEventListener('change', () => {
      // console.log('change');
      // Zkontrolovat, zda URL již obsahuje '?form=editing'
      if (!window.location.href.includes('form=editing') && store.form.currentStep !== 'stepFour' && store.form.formEditing) {
        // Přidat nebo aktualizovat parametr 'form' v URL
        const newUrl = window.location.href.includes('?')
            ? window.location.href + '&form=editing'
            : window.location.href + '?form=editing';

        // Aktualizovat historii bez reloadu stránky
        window.history.pushState({form: 'edit'}, '', newUrl);
      }
    })

    window.addEventListener('popstate', function (event) {
      // console.log('popstate');
      if (store.form.currentStep !== 'stepFour' && store.form.formEditing){
        document.getElementById('modalBtn').click();
      }else if (store.form.currentStep === 'stepFour'){
        window.history.back();
      }
    });

  },
  beforeUnmount() {
    //JJ-818
    const form = document.getElementById('appJakeTrade')
    form.removeEventListener('change', () => {
    });
  },
  methods: {
    continueForm() {
      const newUrl = window.location.href.includes('?')
          ? window.location.href + '&form=editing'
          : window.location.href + '?form=editing';

      // Aktualizovat historii bez reloadu stránky
      window.history.pushState({form: 'edit'}, '', newUrl);
    },
    leaveForm() {
      window.history.back();
    }
  }
}
</script>